import { useState } from "react";

interface ChapterReaderProps {
  images: string[];
  chapterTitle: string;
}

export default function ChapterReader({ images, chapterTitle }: ChapterReaderProps) {
  const [loadedImages, setLoadedImages] = useState<Set<number>>(new Set());

  const handleImageLoad = (index: number) => {
    setLoadedImages((prev) => new Set(prev).add(index));
  };

  return (
    <div className="w-full max-w-2xl mx-auto">
      <div className="text-center mb-6 md:mb-8">
        <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-1">
          {chapterTitle}
        </h2>
        <p className="text-xs text-foreground-500">
          下拉连续阅读 · 畅快体验
        </p>
      </div>
      <div className="space-y-0">
        {images.map((img, index) => (
          <div
            key={index}
            className="relative w-full bg-background-100"
          >
            {!loadedImages.has(index) && (
              <div className="absolute inset-0 flex items-center justify-center bg-background-100">
                <div className="flex flex-col items-center gap-2">
                  <div className="w-8 h-8 border-2 border-primary-300 border-t-primary-500 rounded-full animate-spin"></div>
                  <span className="text-xs text-foreground-400">加载中...</span>
                </div>
              </div>
            )}
            <img
              src={img}
              alt={`${chapterTitle} - 第${index + 1}页`}
              className={`w-full h-auto transition-opacity duration-300 ${
                loadedImages.has(index) ? "opacity-100" : "opacity-0"
              }`}
              onLoad={() => handleImageLoad(index)}
              onError={() => handleImageLoad(index)}
              loading={index < 2 ? "eager" : "lazy"}
              title={`${chapterTitle} - 第${index + 1}页 - 布丁漫画网`}
            />
          </div>
        ))}
      </div>
      <div className="text-center mt-8 py-4">
        <p className="text-sm text-foreground-500">
          — 本章完，继续下滑探索更多精彩 —
        </p>
      </div>
    </div>
  );
}